import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CommonBaseURl } from '../../Commonprovider/CommonProvider';
import { format, parseISO } from 'date-fns';

export const WhatsNew = ({ setShowWhatsnewPopup }) => {
    const [date1, setDate1] = useState('');
    const [date2, setDate2] = useState('');
    const [date3, setDate3] = useState('');
    const [newFeatures1, setNewFeatures1] = useState('');
    const [newFeatures2, setNewFeatures2] = useState('');
    const [newFeatures3, setNewFeatures3] = useState('');
    const Token = useSelector(state => state.Authenticationapi.token);
    const [BaseURL] = useState(CommonBaseURl);

    const formatDateString = (dateString) => {
        if (!dateString) return 'Invalid date';
        try {
            const parsedDate = parseISO(dateString);
            return format(parsedDate, 'MMM d , yyyy');
        }
        catch (error) {
            return 'Invalid Date';
        }
    }


    useEffect(() => {
        const fetchWhatsNewData = async () => {
            try {
                if (Token) {
                    const response = await fetch(`${BaseURL}openCaptalineAWSUpdate`, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",
                            'Authorization': 'Bearer ' + Token.access_token,
                        }
                    });
                    const json = await response.json();
                    if (json.table && json.table.length >= 3) {
                        setDate1(json.table[0].releaseDate);
                        setDate2(json.table[1].releaseDate);
                        setDate3(json.table[2].releaseDate);
                        setNewFeatures1(json.table[0].newFeatures);
                        setNewFeatures2(json.table[1].newFeatures);
                        setNewFeatures3(json.table[2].newFeatures);
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchWhatsNewData();
    }, [Token, BaseURL]);

    // useEffect to handle HTML parsing and formatting
    useEffect(() => {
        parseHTMLContent(newFeatures1, "#htmldiv1");
        parseHTMLContent(newFeatures2, "#htmldiv2");
        parseHTMLContent(newFeatures3, "#htmldiv3");
    }, [newFeatures1, newFeatures2, newFeatures3]);

    const parseHTMLContent = (content, targetSelector) => {
        const targetElement = document.querySelector(targetSelector);        
        if (targetElement) {
            if (content.includes("<html>")) {
                targetElement.innerHTML = content;
                targetElement.querySelectorAll("p").forEach(p => {
                    if (p.innerText.trim() === '') {
                        p.remove();
                    }
                });
            } else {
                targetElement.innerHTML = `<html><pre>${content}</pre></html>`;
                targetElement.querySelectorAll("p").forEach(p => {
                    if (p.innerText.trim() === '') {
                        p.remove();
                    }
                });
            }
        }

    };

    return (
        <div className='modal fade show'
            style={{ display: 'block' }}
            tabIndex="-1"
            role="dialog"
        // ref={modalRef}
        >
            <div className='common-div' onClick={() => setShowWhatsnewPopup(false)}></div>
            <div className='modal-dialog modal-lg'>
                <div className='modal-content'>
                    <div className='landing-box-head'>
                        <h5>What's New</h5>
                    </div>
                    <div className='modal-body common-scroller popup-form'>
                        <div className="form-grup-container flex popup-color">
                            <div className="form-grup name contact-drp">
                                <label for="">{formatDateString(date1)}</label>
                                <ul className='whatnewul'>
                                    <li id="htmldiv1">{newFeatures1}</li>
                                </ul>
                            </div>
                        </div>
                        <div className="form-grup-container flex popup-color">
                            <div className="form-grup name contact-drp">
                                <label for="">{formatDateString(date2)}</label>
                                <ul className='whatnewul'>
                                    <li id='htmldiv2'>{newFeatures2}</li>
                                </ul>
                            </div>
                        </div>
                        <div className="form-grup-container flex popup-color">
                            <div className="form-grup name contact-drp">
                                <label for="">{formatDateString(date3)}</label>
                                <ul className='whatnewul'>
                                    <li id='htmldiv3'>{newFeatures3}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <button type='button' className="bttn-close" onClick={() => setShowWhatsnewPopup(false)}>
                            Close
                        </button>
                        {/* <button type='button' className="bttn">
                            Submit
                        </button> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
